import en from './billManagerStrings.en';

export default {
  en,
};
